import {$router} from "@/dot-ui/index.js";
import {defineAsyncComponent, markRaw} from "vue";
import {routes as dotRoutes} from "@/router/routes/index";
import {routes as nlsRoutes} from "@/tenants/NLS/routes/index";

// ---------------------------------
// 사용 함수
// ---------------------------------
// 도메인 문자열 정규화: 프로토콜/경로 제거, 소문자, localhost → 127.0.0.1
function normalizeDomain(input) {
  if (!input) return "";
  let d = String(input).trim().toLowerCase();
  d = d.replace(/^https?:\/\//, "");
  const slashIdx = d.indexOf("/");
  if (slashIdx !== -1) d = d.slice(0, slashIdx);
  d = d.replace(/^localhost(?=[:/]|$)/, "127.0.0.1");
  return d;
}

// 주어진 domain이 포함된 settings 항목의 키(DOT/KCHF/NLS 등)를 반환
function getCompCode(domain, fallback = "DOT") {
  const target = normalizeDomain(domain);
  const hit = Object.entries(settings).find(([, v]) =>
    Array.isArray(v?.domains) && v.domains.some(d => normalizeDomain(d) === target)
  );
  return hit ? hit[0] : fallback;
}

// ---------------------------------
// 업체별 설정 (key: 업체코드)
// ---------------------------------
const settings = {
  "DOT": {
    routes: dotRoutes,
    domains: [
      "127.0.0.1:9030",
      "dev-account.dotincorp.com",
      "account.dotincorp.com"
    ]
  },
  "NLS": {
    routes: nlsRoutes,
    domains: [
      "127.0.0.1:9031",
      "dev-nls-account.apps-dotincorp.com",
      "nls-account.apps-dotincorp.com"
    ]
  },
};

// ---------------------------------
// 레이아웃 설정
// ---------------------------------
const layouts = {
  "DOT": {
    User: () => import("@/layouts/User.vue"),
    Blank: () => import("@/layouts/Blank.vue"),
  },
  "NLS": {
    User: () => import("@/tenants/NLS/layouts/User.vue"),
    Blank: () => import("@/tenants/NLS/layouts/Blank.vue"),
  }
};


// ---------------------------------
// 업체코드 설정
// ---------------------------------
let domain = $router.getDomain();
const COMP_CODE = getCompCode(domain);
console.log("****COM_CODE = " + COMP_CODE);

const $config = {
  // routes 조회
  getRoutes() {
    return settings[COMP_CODE]?.routes ?? null;
  },
  // layout 조회
  getLayout(name) {
    const loader = layouts[COMP_CODE][name];
    return markRaw(defineAsyncComponent(loader));
  }  
}

export { 
  $config
}